// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_8y-3";
export var contentContainer = "_8y-0";
export var editorContainer = "_8y-1";
export var quillInputForm = "_8y-2";
export var zoneDivider = "_8y-4";